import React from "react";
import A12Y_CONST from "../common/a12yConst";

function PopUpRejoinConfirmation({
  popUpStatus,
  onClose,
  onConfirm,
  subscription,
  currentCount = 0,
}) {
  if (!popUpStatus) return null;

  const title = "Rejoin Advocord";
  const secondaryButtonText = "Cancel";
  const secondaryButtonId = "CancelBtn";

  // Quota calculation logic for billing details
  const planAmount = subscription?.price_details?.plan_amount;
  const renewalAmount = subscription?.price_details?.renewal_amount;
  const planInterval = subscription?.price_details?.plan_interval_display;
  const percentOff = subscription?.price_details?.percent_off;
  const amountOff = subscription?.price_details?.amount_off;
  const hasDiscount = (percentOff != null && percentOff > 0) || (amountOff != null && amountOff > 0);
  const discountText = amountOff ? `$${amountOff.toFixed(2)} Discount` : percentOff ? `($${((planAmount * percentOff / 100) * currentCount).toFixed(2)}) | ${percentOff}% Discount` : '';
  const effectivePrice = amountOff ? planAmount - amountOff : percentOff ? planAmount * (1 - percentOff / 100) : planAmount;
  const totalAmount = planAmount ? (effectivePrice * currentCount).toFixed(2) : '0.00';

  return (
    <div className="popTop ndcPopup__overlay">
      <div className="popContainer popMaxWidth">
        <div className="popMaster">
          <div className="popUpMainBg fullWidth ndcPopup__body">

            {/* Icon */}
            <div className="cancelIcon fullWidth marginTopBottom20">
              <svg xmlns="http://www.w3.org/2000/svg" width="68" height="68" viewBox="0 0 82 82" fill="none">
                <rect x="37.1328" y="19.3396" width="7.73585" height="31.717" fill="#2d6cb2" />
                <circle cx="40.9999" cy="60.3395" r="4.64151" fill="#2d6cb2" />
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0 63.6437 18.3563 82 41 82ZM40.9996 75.0378C59.7982 75.0378 75.0374 59.7986 75.0374 41.0001C75.0374 22.2016 59.7982 6.96235 40.9996 6.96235C22.2011 6.96235 6.96191 22.2016 6.96191 41.0001C6.96191 59.7986 22.2011 75.0378 40.9996 75.0378Z"
                  fill="#2d6cb2" />
              </svg>
            </div>

            {/* Title */}
            <div className="areYouText areYouDmFont texAlingCener">
              {title}
            </div>

            {/* Subtitle */}
            <div className="useInfo ndcPopup__subtitle">
              Please confirm your subscription details to reactivate Advocord
            </div>

            {/* Plan Details Section */}
            <div className="fullWidth marginTop20 ndcPopup__details">

              <div className="ndcPopup__row">
                {/* <div className="ndcPopup__label">Plan Details</div> */}
                <div className="ndcPopup__value">
                  {/* <div className="ndcPopup__planName ndcPopup__planName--themed">Essentials Plan</div> */}
                  {/* <div className="ndcPopup__planBox ndcPopup__planBox--warm">
                    {planInterval} ${planAmount}
                  </div> */}
                  {/* <div className="ndcPopup__planNote">
                    Prices are in US currency and exclude applicable taxes
                  </div> */}
                </div>
              </div>

              <div className="ndcPopup__row ndcPopup__row--center">
                <div className="ndcPopup__label">Active Dependents</div>
                <div className="ndcPopup__countBox ndcPopup__countBox--green">
                  {currentCount}
                </div>
              </div>

              {hasDiscount && (
                <div className="ndcPopup__row ndcPopup__row--center rejoinTotalRow">
                  <div className="ndcPopup__label">Discount Applied</div>
                  <div className="ndcPopup__value ndcPopup__discountValue">{discountText}</div>
                </div>
              )}

              <div className="ndcPopup__row ndcPopup__row--center ndcPopup__row--total rejoinTotalRow">
                <div className="ndcPopup__label ndcPopup__totalLabel">Total Amount</div>
                <div className="ndcPopup__value displayFlex alignItemsCenter">
                  <span className="subscriptionTotalAmount ndcPopup__totalAmount">${(subscription?.subscription_details?.subscription_status.toLowerCase() === 'active' && subscription?.cancel_at_period_end) || subscription?.subscription_details?.subscription_status.toLowerCase() === 'canceled' || subscription?.subscription_details?.subscription_status.toLowerCase() === 'cancelled'? renewalAmount.toFixed(2) : totalAmount.toFixed(2)}</span>
                  <span className="subscriptionTotalPer ndcPopup__totalPer">&nbsp; {A12Y_CONST.LABEL.PER_MONTH}</span>
                </div>
              </div>

            </div>

            {/* Buttons */}
            <div className="fullWidth marginTop30 marginBottom20 ndcPopup__buttons">
              <div id={secondaryButtonId} className="popUpYesButton ndcPopup__btn" onClick={onClose}>
                {secondaryButtonText}
              </div>
              <div id="ConfirmBtn" className="popUpNoButton ndcPopup__btn" onClick={onConfirm}>
                Confirm
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default PopUpRejoinConfirmation;
